export const formatCurrency = (cents: number, decimals: number = 2) => {
    if (!cents) return '$0.00';
    return `$ ${(cents / 100).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals })}`;
};